import React, {
    createContext,
    useContext,
    useMemo,
    useRef,
    useState,
} from 'react';
import { useHeaderOffset } from '../shared/useHeaderOffset';

export const LayoutContext = createContext({
    isPolicy: false,
    headerRef: null,
    sitesNavRef: null,
    policyNavRef: null,
    heroCarouselRef: null,
    site: `unknown`,
    hideNav: false,
    setHideNav: (_: boolean) => {
        /* noop */
    },
    headerOffset: 0,
});

export const LayoutContextProvider = ({ value, children }) => {
    const [hideNav, setHideNav] = useState(false);
    const headerRef = useRef();
    const sitesNavRef = useRef();
    const policyNavRef = useRef();
    const heroCarouselRef = useRef();
    const headerOffset = useHeaderOffset({
        headerRef,
        sitesNavRef,
        policyNavRef,
        isPolicy: value?.isPolicy,
    });

    const contextValue = useMemo(
        () => ({
            ...value,
            headerRef,
            sitesNavRef,
            policyNavRef,
            heroCarouselRef,
            hideNav,
            setHideNav,
            headerOffset,
        }),
        [value, hideNav, headerOffset]
    );

    return (
        <LayoutContext.Provider value={contextValue}>
            {children}
        </LayoutContext.Provider>
    );
};

export const useLayoutContext = () => useContext(LayoutContext);
